import $ from 'jquery';
global.$ = $;
global.jQuery = $;

import 'materialize-css/dist/js/materialize';
import 'materialize-css/dist/css/materialize'
import './../stylesheets/application/base';